import axios from 'axios';
import React, { useEffect , useState} from 'react';
import { GoogleLogin } from '@react-oauth/google';
import {deviceType, getAbsoluteDestinationUrl, createCurrentUrl, certificationPage} from "../../../utils/registrationUtils";
import { useDispatch, useSelector } from "react-redux";
import { postGoogleSignInData } from "../../../../store/slices/Registration/GoogleSignInSlice";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { gaEvent, gaLocationAndContentData } from "../../../utils/index";

function GoogleSignIn() {
  const [widthInPixels, setWidthInPixels] = useState("");
  const { googleSigninData : googleSigninDatas } = useSelector((state) => state.usersGoogleSiginIn);
  const { geoLocation : geoLocationData, userIp : userIpData } = useSelector((state) => state.usersCommonData);
  const { user: _user } = useSelector((state) => state.userData);

  const dispatch = useDispatch(); 
  const navigate = useNavigate();
  const cookies = new Cookies();
  let date = new Date(); // Get current date
  const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME // Determine the destination domain

  // Check and validate the current URL
  const subDomainName = window.location.host?.split(".")[0];
  const urlCheck = window.location.href;
  let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
      window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
  const currentUrl = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
  const urlObj = currentUrl ? new URL(currentUrl) : null;
  const cleanUrl =urlObj ? `${urlObj.origin}${urlObj.pathname}` : null;
  const sourseDestination = cleanUrl ? `${cleanUrl}${window.location.search}` : getAbsoluteDestinationUrl();
  const loginDataCookies = cookies?.get("loginState");
  // -----------useEffects----------
  useEffect(() => {
    // change width to pixels for google sigin library
      const element = document.querySelector('.Google_sigin_outer');
      const widthInPixel = element?.offsetWidth;
      setWidthInPixels(widthInPixel);
  },[])

  useEffect(() => {
    if(!!googleSigninDatas?.ask_complete_profile && !!googleSigninDatas?.user_uuid){
      sessionStorage.setItem("GoogleLogin", JSON.stringify({ user_uuid : googleSigninDatas?.user_uuid, ask_user_name : googleSigninDatas?.ask_user_name, user_type: googleSigninDatas?.user_type, email: googleSigninDatas?.email, isGoogleLogin: 1}));
      cookies.set("loginState", { user_uuid : googleSigninDatas?.user_uuid, ask_user_name : googleSigninDatas?.ask_user_name, user_type: googleSigninDatas?.user_type, email: googleSigninDatas?.email, isGoogleLogin: 1}, {
        path: "/",
        expires: new Date(date.setDate(date.getDate() + 3)),
        sameSite: "Lax",
        domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain,
    });
      navigate(`/user/complete-profile${window.location.search}`)
    }
    if(!!googleSigninDatas?.ask_update_profile && !!googleSigninDatas?.user_id){
      cookies.set("loginState", { ...cookies?.get("loginState") || {}, "user_id": googleSigninDatas?.user_id, "user_type" : googleSigninDatas?.user_type, "google_status": 1, "u_info": googleSigninDatas?.u_info, "email": googleSigninDatas?.email}, {
        path: "/",
        expires: new Date(date.setDate(date.getDate() + 3)),
        sameSite: "Lax",
        domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain,
    });
    navigate(
        `/user/update-profile${window.location.search}`,
        {
            state: {
                user_id: googleSigninDatas?.user_id
            }
        })
    }
  },[googleSigninDatas])

// ----------Functions------------
  const handleSuccess = (response) => {
    const idToken = response.credential; // This contains the Google ID token
    let obj = {};
    obj.current_url = sourseDestination;
    obj.page_url = sourseDestination;
    obj.destination = getAbsoluteDestinationUrl();
    obj.current_location = geoLocationData?.city ? `${geoLocationData?.city},${geoLocationData?.state},${geoLocationData?.country}` : "";
    if(userIpData?.ip){
      obj.ip = userIpData?.ip;
    }
    if(loginDataCookies?.userUuid){
    obj.user_uuid = loginDataCookies?.userUuid;
    }
    dispatch(postGoogleSignInData(obj, idToken));
  };

  const handleError = () => {
    console.error("Login Failed");
  };

  const handleClickEvent = () => {
    gaEvent("continuewithgoogle", "login_signup", `${gaLocationAndContentData}`, "");
  };

  return (
      <>
        <div className='Google_sigin_outer'>
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
            text={"continue_with"} 
            shape={deviceType == "web" ? "circle" : 'rectangular'}
            size={"large"}
            type='standard'
            theme='outline'
            logo_alignment='center'
            width={widthInPixels}
            click_listener={handleClickEvent}
          />
        </div>
        {deviceType == "mobile" ? 
          <div className='mobile_google_sigin_or'>
            <span></span>
              Or  
            <span></span>
          </div> 
          : <></>}
     </>
  );
}

export default GoogleSignIn;


